import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'tk-vehicle-control-indicator-value-type',
    templateUrl: './vehicle-control-indicator-value-type.component.html',
    styleUrls: ['./vehicle-control-indicator-value-type.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class VehicleControlIndicatorValueTypeComponent {
    @Input()
    public type: number = 0;
}
